module.exports = __webpack_public_path__ + "static/media/CONLIFT.5144b7d8.png";